import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CatFinraRejectsGraphComponent } from './cat-finra-rejects-dotted-graph/cat-finra-rejects-graph.component';
import { CatFinraSubmissionFeedbackComponent } from './cat-finra-submission-&-feedback-bar-graph/cat-finra-submission-feedback.component';
import { CatPreValidationDetailsComponent } from './cat-pre-submission-rejects-pie-graph/cat-pre-submission-details.component';
import { CatTransactionErrorGraphComponent } from './cat-pre-validation-rejects-bar-graph/cat-transaction-error-graph.component';
import { CatReportComponent } from './cat-report/cat-report.component';
/* import { CatTransactionCatroeGraphComponent } from './cat-transaction-vs-catroe-line-graph/cat-transaction-catroe-graph.component'; */  /* Keeping it commented for Future Reference */
import { FirmWideCatSummaryComponent } from './firm-wide-cat-summary/firm-wide-cat-summary.component';

@Component({
    selector: 'app-cat',
    imports: [RouterModule, CatReportComponent, CatPreValidationDetailsComponent, CatFinraSubmissionFeedbackComponent,
        /* CatTransactionCatroeGraphComponent, (Keeping it commented for Future Reference)*/ FirmWideCatSummaryComponent, CatTransactionErrorGraphComponent, CatFinraRejectsGraphComponent
    ],
    templateUrl: './cat.component.html',
    styleUrls: ['./cat.component.scss']
})
export class CatComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
